import * as condition from "./condition/index.js";
import * as media from "./media/index.js";
import * as supports from "./supports/index.js";
/**
 * @public
 */
export var Feature;
(function (Feature) {
    Feature.Condition = condition.Condition;
    Feature.And = condition.And;
    Feature.Or = condition.Or;
    Feature.Not = condition.Not;
    Feature.Media = media.Media;
    Feature.Supports = supports.Supports;
    Feature.isMedia = Feature.Media.isMedia;
    Feature.isProperty = Feature.Supports.isProperty;
    Feature.and = Feature.And.of, Feature.isAnd = Feature.And.isAnd;
    Feature.or = Feature.Or.of, Feature.isOr = Feature.Or.isOr;
    Feature.not = Feature.Not.of, Feature.isNot = Feature.Not.isNot;
    Feature.isCondition = Feature.Condition.isCondition;
    Feature.parseMediaQuery = Feature.Media.parse;
    Feature.parseSupportsQuery = Feature.Supports.parse;
})(Feature || (Feature = {}));
//# sourceMappingURL=index.js.map